import { Box, Button } from '@dtx-company/design-system/src'
import { FC } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export const ChangePaymentMethodButton: FC<{
  onShowExistingCreditCardChange: (value: boolean) => void
}> = ({ onShowExistingCreditCardChange }) => {
  return (
    <Box
      sx={theme => ({
        button: {
          color: theme.palette.blue40
        }
      })}
    >
      <Button
        type="button"
        variant={'text'}
        onClick={() => {
          onShowExistingCreditCardChange(false)
        }}
        endIcon={ExpandMoreIcon}
      >
        Change payment
      </Button>
    </Box>
  )
}
